module.exports = "https://bin.bnbstatic.com/_next/static/images/freedom-7ac85a627eb0b730a074879ac8a57977.svg";